import { getRedirectUrlFromShadowItError } from "./shadow-it";

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const redirectToAdminHubForShadowIt = (error: any) => {
    const errorCode = error?.response?.status;
    const redirectUrlShadowIt =
        errorCode === 403 && getRedirectUrlFromShadowItError(error);

    // Shadow IT unauthorized user redirects to adminhub's Shadow IT request flow.
    if (errorCode === 403 && Boolean(redirectUrlShadowIt)) {
        window.location.assign(redirectUrlShadowIt as string);
    }
};
